import { render, staticRenderFns } from "./PurchaserDetailsEditModal.vue?vue&type=template&id=5e471569&scoped=true&"
import script from "./PurchaserDetailsEditModal.vue?vue&type=script&lang=js&"
export * from "./PurchaserDetailsEditModal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaserDetailsEditModal.vue?vue&type=style&index=0&id=5e471569&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e471569",
  null
  
)

export default component.exports